import {getSiweJwt} from "./SiweClient";
import {store} from "../store/Store";

export type WithdrawalRequest = {
    instructionId: string;
    orderSource: string;
    tokenAddress: string;
    amount: string;
    deadline: string;
    signature: string;
}
export type OrderRequest = {
    instructionId: string;
    orderSource: string;
    sellingAsset : string,
    buyingAsset: string,
    amountToSell: string;
    limitAmountToReceive: string;
    deadline: string;
    signature: string;
}


const urls = {
    withdrawal: () => store.config.withdrawal, // POST
    withdrawalStatus: () => store.config.withdrawal, // GET, requires /:instructionId

    balance: () => store.config.balance, // GET requires /:source

    order: () => store.config.order, // POST
    orderStatus: () => store.config.order // GET, requires /:source/:instructionId
}

function getHeaders() {
    return {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + getSiweJwt()
    }
}

async function sendGetRequest(url: string) {
    const request: Request = new Request(url, {
        method: "GET",
        headers: getHeaders()
    });
    return fetch(request);
}

async function sendPostRequest(url: string, payload: object) {
    const request: Request = new Request(url, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(payload)
    });
    return fetch(request);
}

export async function sendWithdrawalRequest(payload: WithdrawalRequest) {
    return await sendPostRequest(urls.withdrawal(), payload);
}
export async function getWithdrawalStatus(instructionId: string) {
    const url: string = urls.withdrawalStatus() + "/" + instructionId;
    return await sendGetRequest(url)
}
export async function sendOrderRequest(payload: OrderRequest) {
    return await sendPostRequest(urls.order(), payload);
}
export async function getOrderStatus(orderSource: string, instructionId: string) {
    const url: string = urls.orderStatus() + "/" + orderSource + "/" + instructionId;
    return await sendGetRequest(url)
}